import React, { FC } from 'react';
import { BoxProps } from '@mui/material';
import classNames from 'classnames';
import ThreeDotIcon from '../../../../components/icon/ThreeDot';
import { getRelativeTime } from '../../../../shared/utils/string/time';
import { Design } from '../../../../shared/types/core/design';

interface MenuCardProps extends BoxProps {
    menu: Design;
    onClickMoreAction: (menu: Design) => void;
    onClickThumbnail: (menuId: number) => void;
    showActions?: boolean;
}

const MenuCard: FC<MenuCardProps> = ({ menu, showActions = true, onClickMoreAction, onClickThumbnail }) => {
    return (
        <div className="rounded-8 bg-white overflow-hidden">
            <div className="relative">
                <img src={menu.thumbnail as string} className="h-150 w-full object-cover object-top cursor-pointer" />
                <div
                    onClick={() => onClickThumbnail(menu.id)}
                    className="cursor-pointer absolute w-full h-full left-0 top-0 bg-gradient-360 z-1"
                />
                <div className="absolute top-6 right-8 flex items-stretch justify-end z-10">
                    {menu.status && (
                        <div
                            className={classNames({
                                'text-10 font-semibold leading-12 p-6 rounded mr-6': true,
                                'bg-success': menu.status === 'LIVE',
                                'bg-warning': menu.status !== 'LIVE',
                            })}
                        >
                            {menu.status}
                        </div>
                    )}
                    {showActions && (
                        <div
                            className="w-24 h-24 bg-white rounded text-3 flex items-center justify-center cursor-pointer"
                            onClick={() => onClickMoreAction(menu)}
                        >
                            <ThreeDotIcon />
                        </div>
                    )}
                </div>
            </div>
            <div className="px-10 pb-10 pt-6" onClick={() => onClickThumbnail(menu.id)}>
                <p className="text-14 font-semibold mb-3 whitespace-nowrap overflow-hidden text-ellipsis">
                    {menu.name}
                </p>
                <p className="text-8 text-primary-80">
                    {menu.updatedAt
                        ? `Last updated ${getRelativeTime(menu.updatedAt)}.`
                        : `Created ${getRelativeTime(menu.createdAt)}.`}
                </p>
            </div>
        </div>
    );
};

export default MenuCard;
